module.exports = __webpack_public_path__ + "img/report_questions.bc109efa.png";